<div class="header">
  <!-- Desktop screen -->
  @if (!isMobile()) {

    <div class="header__left">
      <img
        class="header__logo header__logo--workspace logo"
        [ngClass]="{ 'header__logo--unlocking': isUnlocking }"
        [src]="logoUrl"
        alt="Meplis"
      />
      <app-hub-menu
        [currentHub]="currentHub"
        [triggerStyle]="'workspace'"
        [showExploreMeplis]="showExploreMeplis"
      ></app-hub-menu>
    </div>

    @if(isAuthenticated()){
    <div class="header__right-actions">
      <app-chat-menu></app-chat-menu>

      <div class="header__notification-container">
        <app-notification-menu></app-notification-menu>
      </div>

      <app-profile-avatar
        [profileId]="profileId"
        [disableMenu]="true"
        [matMenuTriggerFor]="profileWidget"
      ></app-profile-avatar>
    </div>
    }@else {
    <div class="header__right-actions">
      <button (click)="goToLogin()" class="btn btn--outline btn--sm">
        <span>{{ 'LOGIN' | translate }}</span>
      </button>
      <button (click)="goToSignUp()" class="btn btn--sm">
        <span>{{ 'SIGN_UP' | translate }}</span>
      </button>
    </div>
    }
  
}

  <!-- profile-widget is the same for web and mobile -->
  <mat-menu #profileWidget="matMenu">
    <app-profile-widget></app-profile-widget>
  </mat-menu>

  <!-- Mobile screen -->
  @if (isMobile()) {
<div class="header-mobile">
    <div class="header-mobile__header">
      <div class="header-mobile__left-side">
        <img
          class="header-mobile__logo header-mobile__logo--workspace logo"
          [ngClass]="{ 'header-mobile__logo--unlocking': isUnlocking }"
          [src]="logoUrl"
          alt="Meplis"
        />

        <app-hub-menu
          [currentHub]="currentHub"
          [triggerStyle]="'workspace'"
          [showExploreMeplis]="showExploreMeplis"
        ></app-hub-menu>
      </div>

      @if(isAuthenticated()){
      <div class="header-mobile__right-side">
        <app-chat-menu></app-chat-menu>

        <app-notification-menu></app-notification-menu>

        <app-profile-avatar
          [profileId]="profileId"
          [disableMenu]="true"
          [matMenuTriggerFor]="profileWidget"
        ></app-profile-avatar>
      </div>
      }@else {
      <div class="header-mobile__right-side">
        <button (click)="goToLogin()" class="btn btn--outline btn--sm">
          <span>{{ 'LOGIN' | translate }}</span>
        </button>
        <button (click)="goToSignUp()" class="btn btn--sm">
          <span>{{ 'SIGN_UP' | translate }}</span>
        </button>
      </div>
      }
    </div>
  </div>
}
</div>
